import * as React from 'react';
import styles from './Footer.module.scss';

const Footer: React.FC = (): React.ReactElement => <p className={styles.paragraph}>Fresenius Kabi AG ©</p>;

export default Footer;
